"use client";

import { Marquee, TextAnimation } from "politicamente-informados-ds";



interface IAttrs {
    text: string;
    backgroundColor: string;
    color?: string;
    repeatLines: number;
    repeatContent: number
    rotateDeg?: number | undefined;
    duration: number;
    direction: string;
    className?: string | undefined;
};



export type IBlockMarquee = {
    attrs: IAttrs;
};


export default function BlockMarquee({ attrs }: { attrs: Record<string, any> }) {
    const {
        className,
        repeatLines = 1,
        repeatContent = 5,
        text = '',
        color,
        backgroundColor,
        duration = 15,
        direction = 'left',
        rotateDeg = 0,
    } = attrs || {};


    return (
        <Marquee
            color={color}
            backgroundColor={backgroundColor}
            duration={duration}
            rotateDeg={rotateDeg}
            direction={direction}
            className={className}>

            <TextAnimation
                repeatLines={repeatLines}
                repeatContent={repeatContent}
                className="marque-text fw-bold lh-1 text-uppercase font-outline-odd d-inline-block h2">
                {text.split("").map((l: string, i: number) => (
                    <span key={"word-" + i}>{l}</span>
                ))}
            </TextAnimation>

        </Marquee>
    );
}
